import { render, staticRenderFns } from "./LevelAndArea.vue?vue&type=template&id=64b91e04&scoped=true"
import script from "./LevelAndArea.vue?vue&type=script&lang=js"
export * from "./LevelAndArea.vue?vue&type=script&lang=js"
import style0 from "./LevelAndArea.vue?vue&type=style&index=0&id=64b91e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b91e04",
  null
  
)

export default component.exports